import { render, staticRenderFns } from "./warning_value.vue?vue&type=template&id=708b89bb&"
import script from "./warning_value.vue?vue&type=script&lang=js&"
export * from "./warning_value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports